<div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="background:url(../../assets/images/big/auth-bg.jpg) no-repeat center center;">
    <div class="auth-box">
        <div>
           
            <!-- Form -->
            <div class="row">
                <div class="col-12">
                    <form verifyForm="ngForm">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">
                                        <span class="text-danger">*</span>Registered Mobile Number</label>
                                        <input type="tel" id="mobileNumber" required
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        #mobileNumber="ngModel" name="mobileNumber" minlength=10 maxlength=15
                                        [(ngModel)]="mobileVerifyAddObj.mobileNumber" class="form-control"
                                        placeholder="Mobile Number">
                                    <span class="text-danger" [hidden]="!mobileNumber.errors.required"
                                        *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">This
                                        Field
                                        is Required
                                    </span>
                                    <span class="text-danger" [hidden]="!mobileNumber.errors?.minlength || mobileNumber.errors.pattern" *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">
                                        Mobile Number Should not exceed 15 digits</span>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label class="control-label">
                                    <span class="text-danger">*</span>OTP</label>
                                <div class="form-group">
                                    
                                    <input type="tel" id="OTP"  class="form-control" required #OTP="ngModel"
                                        name="OTP" [(ngModel)]="mobileVerifyAddObj.OTP"
                                       placeholder="OTP">
                                    
                                </div>
                            </div>
                        </div>

                     
                      
                     
                        <div class="row form-group text-center">
                            <div class="col-12">
                                <a class="btn btn-block btn-lg bg-gradient-primary text-white" type="submit " (click)="verifyMobileNumber()">Submit
                                    </a>
                            </div>
                        </div>
                  
                    </form>
                </div>
            </div>
           
        </div>
    </div>
</div>